import { render, staticRenderFns } from "./ApiForm.vue?vue&type=template&id=a4b898a2&"
import script from "./ApiForm.vue?vue&type=script&lang=js&"
export * from "./ApiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports